export default "__VITE_ASSET__JzAR7eQ0__"